import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "graph",
  "use": "graph-usage",
  "viewBox": "4 6.5 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"4 6.5 16 14\" id=\"graph\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.333 19.496a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v12ZM7 19.496a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v4ZM15.666 19.496a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v8ZM20 19.496a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v2Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol